import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';

import { LoginComponent } from './sessions/login/login.component';
import { RegisterComponent } from './sessions/register/register.component';
import { Error403Component } from './sessions/403.component';
import { Error404Component } from './sessions/404.component';
import { Error500Component } from './sessions/500.component';
import { BoardModule } from './board/board.module';
import { MembersModule } from './members/members.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { ForgotPasswordComponent } from './sessions/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './sessions/reset-password/reset-password.component';

const COMPONENTS: any[] = [
  LoginComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  RegisterComponent,
  Error403Component,
  Error404Component,
  Error500Component,
];
const COMPONENTS_DYNAMIC: any[] = [];

@NgModule({
    imports: [SharedModule, RoutesRoutingModule, BoardModule, MembersModule, DashboardModule, ...COMPONENTS, ...COMPONENTS_DYNAMIC]
})
export class RoutesModule {}
